
<div class="breadcrumbs-row">
    <div class="bc-col mar">
        <ul>
        <ng-container *ngFor="let breadcrumb of pageInfo.urls; let last = last;">
            <li *ngIf="!last" class="cusror"><a href="javascript:void(0)" style="color: gray"> {{breadcrumb.title}} </a></li>
            <li *ngIf="last">{{breadcrumb.title}}</li>
        </ng-container>
        </ul>
    </div>
    <div class="bc-col-btn addserv addvend margin">
    </div>
</div>